import React, {Component} from 'react';
import {ReactiveBase} from "@appbaseio/reactivesearch";
import 'semantic-ui-css/semantic.min.css';
import ExperimentSingleView from './ExperimentSingleView';
const ESCLUSTER ='https://search-dataportal-eado5sdwt6hh6z67rslt5nioby.us-east-1.es.amazonaws.com';
const INDEX = 'echodp';

class ExperimentById extends Component {
  state = {}

  render() {
    return (
      <div className="test">
        <ReactiveBase url={ESCLUSTER} app={INDEX}>
          <ExperimentSingleView id={this.props.match.params.id}/> 
        </ReactiveBase>
      </div>
    );
  }
}

export default ExperimentById;